const MoneyTokenizer = (parts) => {
  const regexp = /([ig]+(?:ld)?d?)|(l?cl?)|(l?f)/g;
  const tokenTypes = ['integer', 'currency', 'fraction'];
  const codifiedParts = parts.map((part) => part.type.substring(0, 1)).join('');
  const transformToken = (position, codifiedPart) => {
    return codifiedPart
      .split('')
      .map((_, index) => {
        return parts[position + index].value;
      })
      .join('');
  };
  const getToken = (matches) => {
    const tokenIndex = matches.slice(1).findIndex((match) => match);
    return {
      value: transformToken(matches.index, matches[tokenIndex + 1]),
      type: tokenTypes[tokenIndex],
    };
  };
  return {
    getToken() {
      const matches = regexp.exec(codifiedParts);
      return matches && getToken(matches);
    },
  };
};

export default MoneyTokenizer;
